import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['skills', 'toggle'];

  static values = { moreLabel: String, lessLabel: String };

  connect() {
    this.expanded = false;
    this.measure();

    // Re-measuring inside the callback would resize the observed element and loop.
    this.observer = new ResizeObserver(([entry]) => {
      const { width } = entry.contentRect;
      if (width === this.lastWidth) return;

      this.lastWidth = width;
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.measure());
    });
    this.observer.observe(this.skillsTarget);
  }

  disconnect() {
    cancelAnimationFrame(this.frame);
    this.observer?.disconnect();
  }

  toggle() {
    this.expanded = !this.expanded;
    this.apply();
  }

  measure() {
    const chips = this.chips();
    if (chips.length === 0) return;

    chips.forEach(chip => { chip.hidden = false; });

    const firstRowTop = chips[0].offsetTop;
    this.overflow = chips.filter(chip => chip.offsetTop > firstRowTop);
    this.lastWidth = this.skillsTarget.getBoundingClientRect().width;
    this.apply();
  }

  apply() {
    const hidden = this.overflow?.length ?? 0;
    this.toggleTarget.hidden = hidden === 0;
    if (hidden === 0) return;

    this.overflow.forEach(chip => { chip.hidden = !this.expanded; });
    this.toggleTarget.textContent = this.expanded
      ? this.lessLabelValue
      : `${this.moreLabelValue} (${hidden})`;
    this.toggleTarget.setAttribute('aria-expanded', String(this.expanded));
  }

  chips() {
    return Array.from(this.skillsTarget.children);
  }
}
